
<template>
    <LandingPage>
      <template slot="taption_header">
        <div id="text1-strings">
          <p>Transcribe</p>
          <p>ChatGPT for</p>
          <p>Translate</p>
          <p>Add subtitles to</p>
        </div>
        <span id="text1"></span>your video.</template>
      <template slot="landing_description">Automatically create transcripts, translations, subtitles and analyze your videos in 40+ languages.</template>

      <template slot="intro_video">
    
          <video playsinline class="intro-video" :src='"@/assets/video/landing_en.mp4"' autoplay frameborder="0" height="350" width="575" muted></video>
      </template>

      <template slot="start_your_trial">TRY TAPTION</template>

      <template slot="use_case_title">Product features.</template>
      <template slot="youtubers">Convert video to text</template>
      <template slot="youtubers_question">Transcribe your videos and automatically generate captions and subtitles</template>


      <template slot="journalists">AI Analysis</template>
      <template slot="journalists_question">Summarize video, generate topics, and create Youtube chapters. Have your own custom ChatGPT</template>
      <!-- <template slot="youtubers">Convert video to text</template>
      <template slot="youtubers_question">Automated transcription for your video from your device, Youtube, Google Drive or Zoom</template>


      <template slot="journalists">Add subtitles to your video</template>
      <template slot="journalists_question">Automatically add captions or bilingual subtitles to your video</template> -->
     
      <template slot="translators">Translate video</template>
      <template slot="translators_question">Translate your subtitles and transcripts into over 50 languages</template>

      <template slot="speaker">Speaker labeling</template>
      <template slot="speaker_question">Convert audio to text and label speakers in your recordings</template>

      <template slot="audiotomp4">Convert your audio to video</template>
      <template slot="audiotomp4_question">Take your audio file and an image to convert into a MP4 video with captions</template>

      <template slot="importsrt">Convert TXT to SRT</template>
      <template slot="importsrt_question">Add timestamps to text and format automatically.</template>

      <template slot="share">Collaborate with teams</template>
      <template slot="share_question">Share accounts and customize features with user permissions management</template>

      <template slot="learnmore">Learn more</template>
      

      <template slot="simple_workflow">Simple workflow.</template>
      <template slot="upload">Upload</template>
      <template slot="upload_description">Upload your video to our platform or use our YouTube transcript generator to directly transcribe from YouTube. You can also upload files from Zoom, Webex, and Google Drive. </template>
      <template slot="edit_translate">Edit</template>
      <template slot="edit_translate_description">Edit your transcript without worrying about adjusting the time stamps. Additionally our online video editor let you directly edit your video on the platform. </template>
      <template slot="transcribe">AI Analysis</template>
      <template slot="transcribe_description">Ask any questions to query video content. We provide common templates, such as creating timestamped YouTube chapters, summarizing videos, generating YouTube summaries, and video topic generators.</template>
      <template slot="translate">Translate</template>
      <template slot="translate_description">Our online translation supports 40+ languages, outperforming particularly in translations between cross-regional languages such as English to Chinese, English to Japanese, English to Vietnamese or vice versa.</template>
      <template slot="export">Export</template>
      <template slot="export_description">After finishing subtitle editing and video editing, you can export in MP4 with embedded subtitles, SRT, VTT, PDF, and TXT files.</template>
      <template slot="try_it_now">Try it now</template>


      <template slot="editing_platform_desc1">Taption's timeline feature simplifies video editing. When edits overlap with subtitles, it automatically adjusts text and timing, ensuring accuracy and synchronization. Our online video editor is perfect for quick edits, easily creating professional subtitled videos.</template>
      <template slot="video_time_stampped">
            <div class="video-wrapper" @click="onClicked('video1', true)">
                  <button v-show="!videoState.video1" class="play"></button>
                  <video id="video1" ref="video1" playsinline class="unique-video" poster="../assets/images/thumbnail/cut_thumbnail_en.webp" :src='"@/assets/video/Trim_Cut_en.mp4"' frameborder="0" height="300"  width="575" muted></video>
            </div>
      </template>
      
      <template slot="editing_platform">Incredible editing platform.</template>
      <template slot="editing_platform_desc0">In addition to subtitle and transcript editing, our subtitle generator platform allows for precise video editing directly through subtitles. It automatically adjusts the timing of other subtitles to match the edited video, ensuring smooth and synchronized playback.</template>
      <template slot="video_trimmed">
            <div class="video-wrapper" @click="onClicked('video0', true)">
                  <div class="play-button" v-show="!videoState.video0">
                    <a class="popup-vimeo animated-circle" ><img :src='"../assets/images/play-button.webp"' alt="play-button" class="img-fluid" /></a>
                </div>
          <video id="video0" ref="video0" playsinline preload="none" class="intro-video" poster="../assets/images/thumbnail/trim_thumbnail_en_US.webp" :src='"@/assets/video/Trim_English.mp4"' frameborder="0" height="350" width="575" muted></video>
            </div>
      </template>

 
      <template slot="editing_platform_desc2">Our AI analysis feature boosts video understanding by creating video summaries, identifying key points, and enabling content searches. Additionally, it offers commonly used templates including creating YouTube chapters, generating video topics, and correcting subtitles, enhancing the video editing process.</template>
      <template slot="video_replace_all">
          <div class="video-wrapper" @click="onClicked('video2', true)">
              <div class="play-button" v-show="!videoState.video2">
                    <a class="popup-vimeo animated-circle" ><img :src='"../assets/images/play-button.webp"' alt="play-button" class="img-fluid" /></a>
                </div>
              <video id="video2" ref="video2" playsinline preload="none" poster="../assets/images/thumbnail/analysis_thumbnail_en.webp" class="unique-video" :src='"@/assets/video/AI_Analysis_en.mp4"' frameborder="0" height="300"  width="575" muted></video>
          </div>
      </template>
      <template slot="editing_platform_desc3">Memos allow you to add memos at specific timestamps in your video transcript, creating notes for other users to view. Users can quickly navigate to the corresponding video segments using these memos, improving the video-to-text conversion process. This tool is useful for video editing, generating subtitles, and creating YouTube chapters or summaries.</template>
      <template slot="video_add_dictionary">
        <div class="video-wrapper" @click="onClicked('video3', true)">
              <div class="play-button" v-show="!videoState.video3">
                  <a class="popup-vimeo animated-circle" ><img :src='"../assets/images/play-button.webp"' alt="play-button" class="img-fluid" /></a>
                </div>
              <video id="video3" ref="video3" playsinline preload="none" poster="../assets/images/thumbnail/memo_thumbnail_en.webp" class="unique-video" :src='"@/assets/video/Memo_en.mp4"' frameborder="0" height="300"  width="575" muted></video>
          </div>
      </template> 

                   

      <template slot="low_cost">Affordable pricing.</template>
      <template slot="title_basic">Pay as you go</template>
      <template slot="basic_cost_usd">$8</template>
      <template slot="basic_cost_ntd">(240 NTD)</template>
      <template slot="hour">hour</template>
      <template slot="basic_feature5">Credit <span style="color: #00d1b2;">60 minutes</span></template>
      <template slot="basic_feature1">Automated transcription</template>
      <template slot="basic_feature2">40+ languages supported</template>
      <template slot="basic_feature3">Highlighted text editor</template>
      <template slot="basic_feature4">Translate into 50+ languages</template>
      <template slot="basic_feature7">Personal AI Dictionary</template>
      <template slot="basic_feature6">Allow for commercial use</template>
      <template slot="basic_feature8">Supports burned-in multi-language subtitles</template>

      <template slot="title_premium">Premium Subscription</template>
      <template slot="premium_cost_usd">$12</template>
      <template slot="premium_cost_ntd">(360 NTD)</template>
      <template slot="premium_basic_cost_usd">$6</template>
      <template slot="month">month</template>

      <template slot="premium_before"><span class="landing-arrow-left">&#10229;</span>All features in「Pay as you go」</template>
      <template slot="premium_feature1"><span style="color: #00d1b2;">120 minutes</span> credit to your account every month.<br><span style="color:#797676;font-size:14px;font-weight: 100;">(Carryover minutes, valid until subscription canceled)</span></template>
      <template slot="premium_feature1_tooltip">If the monthly minutes are not consumed, they will be carried over to the next month and will be valid until the subscription is canceled. <br>These monthly minutes are used before the additional minutes purchased separately. <br>The additional minutes purchased separately do not expire after the subscription is canceled.</template>
      <template slot="premium_feature2">25% discount on hourly purchases</template>
      <template slot="premium_feature3">Unlimited burned-in subtitles exports for free</template>
      <template slot="premium_feature4">Editable transcript sharing</template>
      <template slot="premium_feature5">Export your audio recordings to videos with subtitles</template>
      <template slot="premium_feature6">Video cutting (Exported transcript/subtitles will auto adjust)</template>

      <template slot="title_corp">Bulk Subscription</template>
      <template slot="bulk_cost_usd">$69</template>
      <template slot="bulk_cost_ntd">(2070 NTD)</template>
      <template slot="bulk_basic_cost_usd">$4</template>
      <template slot="bulk_before"><span class="landing-arrow-left">&#10229;</span>All features in「Pay as you go」and「Premium Subscription」</template>
       <template slot="bulk_feature2">63% discount on hourly purchases</template>
      <template slot="premium_feature1_bulk"><span style="color: #00d1b2;">1000 minutes</span> credit to your account every month.<br><span style="color:#797676;font-size:14px;font-weight: 100;">(Carryover minutes, valid until subscription canceled)</span></template>
      <template slot="bulk_feature1">Provide receipts download with your institution name and tax id</template>

       <template slot="bulk_feature3">Share minutes with users</template>
       <template slot="bulk_feature4">6 different configurable permissions</template>

      <template slot="go_to_price">More details</template>
    </LandingPage>
</template>

<script>
import LandingPage from "./LandingPage";
//import Typed from 'typed.js';
export default {
  data: () => ({
      videoState:{
          video0:false,
          video1:false,
          video2:false,
          video3:false  
      }
  }),
  components: {
    LandingPage
  },
  methods: {
    onClicked(videoType, isPlay){
        const me = this;
        me.$refs[videoType].play();
        me.videoState[videoType] = isPlay;
    }
  },
  mounted(){
    const me = this;
    const video0 = document.getElementById("video0");  
    const video1 = document.getElementById("video1");   
    const video2 = document.getElementById("video2");   
    const video3 = document.getElementById("video3");   

    if(video0){
        video0.onended = function() {
            me.videoState.video0 = false;
        }
        // video0.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video0 = false;
        // } 
    }

    if(video1){
        video1.onended = function() {
            me.videoState.video1 = false;
        }
        // video1.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video1 = false;
        // } 
    }

    if(video2){
        video2.onended = function() {
            me.videoState.video2 = false;
        } 
        // video2.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video2 = false;
        // } 
    }


    if(video3){
        video3.onended = function() {
            me.videoState.video3 = false;
        } 
        // video3.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video3 = false;
        // } 
    }
  }
}

</script>


           